export const copyTextToClipboard = async (textToCopy: string) =>
  await navigator.clipboard.writeText(textToCopy);
